import { render, staticRenderFns } from "./SendMessageGroupEdit.vue?vue&type=template&id=3d9c812d&scoped=true&lang=pug"
import script from "./SendMessageGroupEdit.vue?vue&type=script&lang=ts"
export * from "./SendMessageGroupEdit.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageGroupEdit.vue?vue&type=style&index=0&id=3d9c812d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c812d",
  null
  
)

export default component.exports